var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-overlay',{attrs:{"id":"mainOverlay","show":true,"rounded":"sm"}},[_c('div',{staticStyle:{"position":"relative","height":"100vh","width":"100%","display":"table"}})]),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"mainRouterView"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }